/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Folder_PropertyInputs */

const cs_folder_property = /** @type {(inputs: Folder_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost`)
};

const en_folder_property = /** @type {(inputs: Folder_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Folder_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const folder_property = /** @type {((inputs?: Folder_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Folder_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_folder_property(inputs)
	return cs_folder_property(inputs)
});